var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import Chart from "react-apexcharts";
import CardChart from "./Charts";
import { useTranslation } from "react-i18next";
export var VotingChanel;
(function (VotingChanel) {
    VotingChanel["Online"] = "Online";
    VotingChanel["Paper"] = "Paper";
    VotingChanel["Telephone"] = "Telephone";
    VotingChanel["Postal"] = "Postal";
})(VotingChanel || (VotingChanel = {}));
export var VotersByChannel = function (_a) {
    var data = _a.data, width = _a.width, height = _a.height;
    var t = useTranslation().t;
    var state = {
        options: {
            labels: data.map(function (item) { return item.channel.toString(); }),
            plotOptions: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            total: {
                                showAlways: true,
                                show: true,
                            },
                        },
                    },
                },
            },
        },
        series: data.map(function (item) { return item.count; }),
    };
    return (_jsx(CardChart, __assign({ title: t("dashboard.votersByChannels") }, { children: _jsx(Chart, { options: state.options, series: state.series, type: "donut", width: width, height: height }) })));
};
